import {
  Chip,
  FormControlLabel,
  Paper,
  Radio,
  Stack,
  Typography,
} from '@rossum/ui/material';
import { useIntl } from 'react-intl';

export const ExtensionVersionOption = ({
  value,
  label,
  description,
  isLatest,
}: {
  value: string;
  label: string;
  description: string | undefined;
  isLatest: boolean;
}) => {
  const intl = useIntl();
  return (
    <Stack
      key={value}
      spacing={1}
      component={Paper}
      sx={{
        label: {
          m: 0,
          p: 2,
          width: '100%',
          justifyContent: 'space-between',
        },
      }}
    >
      <FormControlLabel
        value={value}
        control={<Radio size="small" />}
        slotProps={{
          typography: {
            variant: 'body2',
          },
        }}
        labelPlacement="start"
        label={
          <Stack spacing={0.5} mr={1}>
            <Stack direction="row" sx={{ gap: 1 }}>
              <Typography variant="h6">{label}</Typography>
              {isLatest ? (
                <Chip
                  label={intl.formatMessage({
                    id: 'features.externalStore.drawer.recommended',
                  })}
                  color="info"
                />
              ) : null}
            </Stack>
            {description ? (
              <Typography variant="caption" color="textSecondary">
                {description}
              </Typography>
            ) : null}
          </Stack>
        }
      />
    </Stack>
  );
};
